// NOTES
//-------------------------------------------------------------------------------------------------------------------------
//  This is outdated, but I'm keeping it for now as historical reference to the gnarly regex strings
//
//      6/20: Database reg ex pattern changed (couldn't figure out how to pass /i flag to angular pattern, so just embedded it in the expressions, bleh.)
//          old: ^(([0129BE][0-9A-Z]+)|([A-Z][A-Z][A-Z][A-Z][A-Z])|([A-Z][A-Z][A-Z][A-Z0-9])|([A-Z][A-Z][A-Z][0-9][0-9])|[A-Z][A-Z][A-Z]|([A-Z][A-Z])|([A-Z]))$
//          new: ^[0129EVev][0-9A-Za-z]+|^[Bb]0+|^[LlRr]+|^[A-Za-z]$|^[A-Za-z][A-Za-z]$|^[A-Za-z][A-Za-z][A-Za-z]+

// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component, ViewEncapsulation, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

//Third Party
import moment from 'moment';
import { switchMap } from 'rxjs/operators';

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { CPDFormatters } from '../../shared/services/cpd-formatters';
import { GrowlWrapperService } from '../../shared/services/growlWrapperService';
import { WebServices } from '../../shared/services/webServices';
import { FeatureFlagService } from '../../shared/services/featureFlagService';

//Classes
import { Practice } from "../../shared/classes/practice.js";
import { FormField } from "../../shared/classes/formField";

//Library
import { CASValidate } from '../../shared/library/casValidate';
//import { BCGrowls } from '../../shared/library/bcGrowls';

//Config/GLobals
import { Enums } from '../../shared/enums.js';

//Token
import { authToken } from '../../shared/authToken';
import { FormAction } from '../../shared/classes/formAction';
import { Helpers } from '../../shared/services/helpers';
import { exportCsvDTO } from '../../shared/library/export';


// LOCALS
//-------------------------------------------------------------------------------------------------------------------------


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// PracticesEditComponent
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
  selector:'practices-editV2',
  template : '<div class="cpd-main-div" data-test-id="content_practice_edit">\n\n    <!--Title-->\n    <h2 tabindex="-1" class="cpd-title-div">\n        {{_title}}\n        <span *ngIf="_dirty" style="position:relative; top:-2px; color:#b70f0a; font-size:14px;">&nbsp;(updated)</span>\n    </h2>\n\n    <!--For 508-->\n    <div style="position:relative; top:-5px; padding-left:10px;"><span style="color:#b70f0a;">*</span> indicates a required field</div>\n\n    <div style="height:10px;"></div>\n\n    <!--Content Loading -->\n    <div *ngIf="casNavBoxService.ActionsLoading || _practiceLoading || !_currentPractice" class="cpd-ui-content-loading">\n        <img src="public/cpd-images/loading.gif" />\n        <div style="margin-left:10px;">Loading...</div>\n    </div>\n\n\n    <!--Content Div -->\n    <!--<div *ngIf="!casNavBoxService.ActionsLoading && !_practiceLoading && !!_currentPractice; else loading">-->\n    <div id="pe_main_content_div" style="margin-top:10px;overflow:hidden;" [style.display]="(!casNavBoxService.ActionsLoading && !_practiceLoading && !!_currentPractice) ? \'block\' : \'none\'">\n\n        <div class="cpd-ui-row" style="padding: 15px 10px 10px 10px;" data-test-id="section_practice_edit_asset_type">\n\n            <!--=====================================================================-->\n            <!-- Asset Type -->\n            <!--=====================================================================-->\n            <div id="gcAssetType" class="cpd-ui-cell" style="flex-grow:1;">\n\n                <div id="ghdAssetType" class="cpd-ui-group-lbl" role="heading" aria-level="3"><h3>Asset Type</h3></div>\n\n                <!-- ---------------------------------------------------- -->\n                <!--Asset Types Dropdown-->\n                <!-- ---------------------------------------------------- -->\n                <div class="cpd-ui-field-div" [hidden]="!_fields.assetTypes.show">\n                    <label for="selAssetTypeFilter" style="width:90px;" aria-label="Asset Type" title="Asset Type Filter">\n                        Asset Type\n                        <span class="cpd-required" aria-label="required">*</span>\n                    </label>\n\n                    <!--For now, this is enabled in "revise mode" until the business has migrated to the new practice types-->\n                    <select *ngIf="!_fields.assetTypes.read_only"\n                            id="selAssetTypeFilter"\n                            [(ngModel)]="_selectedAssetTypeFilter"\n                            data-cval-msg-element-id="selAssetTypeFilter_vmsg"\n                            data-cval-fld-name="Asset Type"\n                            data-cval-dropdown-selected="true"\n                            [disabled]="_allFieldsDisabled ? \'true\' : null"\n                            class="cval {{ _allFieldsDisabled || _fields.assetTypes.read_only ? \'cpd-ui-field-readonly\' : \'\' }}"\n                            (change)="assetFilterChanged($event)">\n                        <option *ngFor="let assetType of _assetTypeFilters;" [ngValue]="assetType">{{assetType.practice_type_code_display}}</option>\n                    </select>\n                    <input *ngIf="_fields.assetTypes.read_only" id="selAssetTypeFilter" readonly="readonly" class="cpd-ui-field-readonly" [(ngModel)]="_selectedAssetTypeFilter.practice_type_code_display">\n                </div>\n\n                <!--validation message-->\n                <div id="selAssetTypeFilter_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n                <!-- ---------------------------------------------------- -->\n                <!--Asset Type Description-->\n                <!-- ---------------------------------------------------- -->\n                <div class="cpd-ui-field-div">\n                    <label for="asset_type_description" style="width:90px;" aria-label="Asset Type Description" title="Asset Type Description">Asset Type Description</label>\n                    <input id="asset_type_description" type="text" name="asset_type_description"\n                           style="flex-grow:1;"\n                           class="cpd-ui-field-readonly"\n                           (input)="_formChanged($event)"\n                           [attr.readonly]="_fields.assetTypes.read_only"\n                           [ngModel]="_currentPractice?.practice_type_code_description" (ngModelChange)="_currentPractice.practice_type_code_description=$event" />\n                </div>\n\n                <!-- ---------------------------------------------------- -->\n                <!--Business Rule Description-->\n                <!-- ---------------------------------------------------- -->\n                <div class="cpd-ui-field-div" style="display: flex; align-items:flex-start; justify-content:flex-start;">\n                    <label for="business_rule_description" style="width:90px;" aria-label="Business Rule Description" title="Business Rule Description">Business Rule Description</label>\n                    <textarea id="business_rule_description"\n                              rows="4" style="flex-grow:1;" name="business_rule_description"\n                              class="cpd-ui-field-readonly"\n                              (input)="_formChanged($event)"\n                              readonly="readonly"\n                              [attr.maxLength]="500"\n                              [ngModel]="_currentPractice?.business_rule_description" (ngModelChange)="_currentPractice.business_rule_description=$event"></textarea>\n                </div>\n\n                <div>\n                    <span title=\'Current Asset Type Rules\' class=\'fake-anchor\' tabindex="0" (click)="_showBusinessRulePopup()" (keyup.enter)="_showBusinessRulePopup()">View Current Asset Type Rules</span>\n                </div>\n\n\n            </div>\n        </div>\n\n        <!-- Practice Code & Units & States "Row"-->\n        <!-- ------------------------------------------------------------------------------------------------------------- -->\n        <div class="cpd-ui-row" data-test-id="section_practice_edit_code" style="padding: 10px 10px 10px 10px;">\n\n            <!--=====================================================================-->\n            <!-- Practice Codes -->\n            <!--=====================================================================-->\n            <div id="gcCodes" class="cpd-ui-cell">\n\n                <div id="ghdCodes" class="cpd-ui-group-lbl" role="heading" aria-level="3"><h3>Codes</h3></div>\n\n                <!-- ---------------------------------------------------- -->\n                <!--practice_code-->\n                <!-- ---------------------------------------------------- -->\n                <!--Note that the default "read only" state in the DB for practice code has to be overridden for new\n                    practices as the user has to be able to enter the code-->\n                <div class="cpd-ui-field-div" [hidden]="!_fields.practice_code.show">\n                    <label for="practice_code" style="width:120px;">Asset&nbsp;Code<span class="cpd-required" aria-label="required">*</span></label>\n                    <input id="practice_code"\n                           name="practice_code"\n                           type="text"\n                           data-cval-msg-element-id="practice_code_vmsg"\n                           data-cval-fld-name="Asset Code"\n                           [attr.data-cval-required]="true"\n                           [attr.data-cval-range]="_currentPractice?.business_rule_range"\n                           [attr.data-cval-starts-with]="_currentPractice?.business_rule_starts_with"\n                           style="width:75px;"\n                           class="cval {{ !_currentPractice?.practice_type_code || _allFieldsDisabled || !_new_practice || _fields.practice_code.read_only ? \'cpd-ui-field-readonly\' : \'\'}}"\n                           [attr.readonly]="!_currentPractice?.practice_type_code || _allFieldsDisabled || !_new_practice || _fields.practice_code.read_only ? true : null"\n                           [attr.maxLength]="10"\n                           (input)="_practiceCodeChanged(); _formChanged($event)"\n                           [ngModel]="_currentPractice?.practice_code" (ngModelChange)="_currentPractice.practice_code=$event" />\n                </div>\n\n                <!--validation message-->\n                <div id="practice_code_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n                <!-- ---------------------------------------------------- -->\n                <!--replacement_code-->\n                <!-- ---------------------------------------------------- -->\n                <div class="cpd-ui-field-div" [hidden]="!_fields.replacement_code.show">\n                    <label for="replacement_code" style="width:120px;">Replacement Code</label>\n                    <input id="replacement_code"\n                           type="text"\n                           name="replacement_code"\n                           data-cval-msg-element-id="replacement_code_vmsg"\n                           data-cval-fld-name="Replacement Code"\n                           [attr.data-cval-required]="false"\n                           [attr.data-cval-range]="_currentPractice?.business_rule_range"\n                           [attr.data-cval-starts-with]="_currentPractice?.business_rule_starts_with"\n                           style="width:75px;"\n                           class="cval {{ (_fields.replacement_code.read_only || _allFieldsDisabled) ? \'cpd-ui-field-readonly\' : \'\' }}"\n                           (input)="_formChanged($event)"\n                           [attr.readonly]="(_fields.replacement_code.read_only || _allFieldsDisabled) ? \'readonly\' : null"\n                           [attr.maxLength]="10"\n                           [ngModel]="_currentPractice?.replacement_code" (ngModelChange)="_currentPractice.replacement_code=$event" />\n                </div>\n\n                <!--validation message-->\n                <div id="replacement_code_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n                <!-- ---------------------------------------------------- -->\n                <!--reporting_code-->\n                <!-- ---------------------------------------------------- -->\n                <div class="cpd-ui-field-div" [hidden]="!_fields.reporting_code.show">\n                    <label for="reporting_code" style="width:120px;">Reporting Code</label>\n                    <input id="reporting_code" type="text" name="reporting_code"\n                           data-cval-msg-element-id="reporting_code_vmsg"\n                           data-cval-fld-name="Reporting Code"\n                           [attr.data-cval-required]="false"\n                           [attr.data-cval-range]="_currentPractice?.business_rule_range"\n                           [attr.data-cval-starts-with]="_currentPractice?.business_rule_starts_with"\n                           style="width:75px;"\n                           class="cval {{ (_fields.reporting_code.read_only || _allFieldsDisabled) ? \'cpd-ui-field-readonly\' : \'\'}}"\n                           (input)="_formChanged($event)"\n                           [attr.readonly]="(_fields.reporting_code.read_only || _allFieldsDisabled) ? \'readonly\' : null"\n                           [attr.maxLength]="10"\n                           [ngModel]="_currentPractice?.reporting_code" (ngModelChange)="_currentPractice.reporting_code=$event" />\n                </div>\n\n                <!--validation message-->\n                <div id="reporting_code_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n            </div>\n\n            <!--=====================================================================-->\n            <!-- Measurement Units -->\n            <!--=====================================================================-->\n            <div id="gcUnits" class="cpd-ui-cell" style="display:flex; flex-direction:column; flex-grow:1;">\n\n                <div id="ghdUnits" class="cpd-ui-group-lbl" role="heading" aria-level="3"><h3>Units</h3></div>\n\n                <!--Top-->\n                <div style="display:flex;">\n\n                    <div style="margin:5px 5px 5px 5px;">\n\n                        <!-- ---------------------------------------------------- -->\n                        <!--Practice Units-->\n                        <!-- ---------------------------------------------------- -->\n                        <div class="cpd-ui-field-div" [hidden]="!_fields.measurement_unit_id.show">\n                            <label for="sel_measurement_unit" style="width:115px;">Asset Unit<span class="cpd-required" aria-label="required">*</span></label>\n                            <select *ngIf="!_fields.measurement_unit_id.read_only"\n                                    id="sel_measurement_unit"\n                                    name="sel_measurement_unit"\n                                    data-cval-msg-element-id="sel_measurement_unit_vmsg"\n                                    data-cval-fld-name="Asset Unit"\n                                    data-cval-dropdown-selected="true"\n                                    class="cval {{ (_fields.measurement_unit_id.read_only || _allFieldsDisabled) ? \'cpd-ui-field-readonly\' : \'\'}}"\n                                    [attr.readonly]="(_fields.measurement_unit_id?.read_only || _allFieldsDisabled) ? \'readonly\' : null"\n                                    (change)="_formChanged($event)"\n                                    [ngModel]="_currentPractice?.measurement_unit_id" (ngModelChange)="_currentPractice.measurement_unit_id=$event">\n\n\n                                <option *ngFor="let unit of _measurements" [ngValue]="unit.measurement_unit_id">{{unit.measurement_unit_name}}</option>\n                            </select>\n                            <input *ngIf="_fields.measurement_unit_id.read_only" id="sel_measurement_unit" readonly="readonly" class="cpd-ui-field-readonly" [value]="_getUnitDisplay(_currentPractice?.measurement_unit_id)">\n                        </div>\n\n                        <!--validation message-->\n                        <div id="sel_measurement_unit_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n                        <!-- ---------------------------------------------------- -->\n                        <!--shape_type-->\n                        <!-- ---------------------------------------------------- -->\n                        <!--This control ignores most DB form-fields settings as it is not properly set up for any possible input-->\n                        <div class="cpd-ui-field-div" [hidden]="!_fields.shape_type.show">\n                            <label for="shape_type" style="width:115px;">Shape Type</label>\n                            <input id="shape_type" name="shape_type"\n                                   class="cpd-ui-field-readonly"\n                                   style="width:75px;"\n                                   readonly="readonly"\n                                   (input)="_formChanged($event)"\n                                   [value]="_getShapeType()" />\n                        </div>\n\n                    </div>\n                </div>\n\n                <!--Divider (middle)-->\n                <div style="border-top:solid 1px #ccc; border-bottom:solid 1px #fff; height:2px; margin:0 10px 10px 10px;"></div>\n\n                <!--Bottom-->\n                <div style="display:flex;">\n\n                    <!--Bottom-Left-->\n                    <div style="margin:5px 5px 5px 5px;">\n\n                        <!-- ---------------------------------------------------- -->\n                        <!--installed_practice_lifespan_years-->\n                        <!-- ---------------------------------------------------- -->\n                        <div class="cpd-ui-field-div" [hidden]="!_fields.installed_practice_lifespan_years.show">\n                            <label for="installed_practice_lifespan_years">Maximum Lifespan<span class="cpd-required" aria-label="required">*</span></label>\n                            <input id="installed_practice_lifespan_years" name="installed_practice_lifespan_years" type="text"\n                                   data-cval-msg-element-id="installed_practice_lifespan_years_vmsg"\n                                   data-cval-fld-name="Maximum Lifespan"\n                                   [attr.data-cval-required]="true"\n                                   style="width:75px;"\n                                   class="cval {{ (_fields.installed_practice_lifespan_years.read_only || _allFieldsDisabled) ? \'cpd-ui-field-readonly\' : \'\' }}"\n                                   (input)="_formChanged($event)"\n                                   [attr.readonly]="(_fields.installed_practice_lifespan_years.read_only || _allFieldsDisabled) ? \'readonly\' : null"\n                                   [ngModel]="_currentPractice?.installed_practice_lifespan_years" (ngModelChange)="_currentPractice.installed_practice_lifespan_years=$event" />\n                        </div>\n\n                        <!--validation message-->\n                        <div id="installed_practice_lifespan_years_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n                    </div>\n\n\n                </div>\n\n            </div>\n\n            <!--=====================================================================-->\n            <!-- Authorized States -->\n            <!--=====================================================================-->\n            <!--<div *ngIf="_fields_hash?.sec_authorized_states?.field_show" class="cpd-ui-cell" style="">-->\n            <div [hidden]="!_fields.sec_authorized_states.show || _flag_FSAPractice" id="gcAuthStates" class="cpd-ui-cell">\n\n                <div id="ghdAuthStates" class="cpd-ui-group-lbl" role="heading" aria-level="3"><h3>Authorized&nbsp;States</h3></div>\n\n                <!--State Lists-->\n                <div style="display: flex; margin: 10px; align-items: center; ">\n                    <!--Left-->\n                    <cas-grid #unauthorizedStatesGrid\n                              summary="Unauthorized States List"\n                              name="unauthorizedStatesGrid"\n                              [disabled]="(_fields.sec_authorized_states.read_only || _allFieldsDisabled) ? \'disabled\' : null"\n                              [settings]="_unauthorizedStates_gridSettings"></cas-grid>\n\n                    <!--Old Buttons-->\n                    <!--<div style="display:flex; flex-direction:column;">\n\n                        <div tabindex="0" title="Remove All States" aria-label="Remove All States"\n                             (click)="_removeAllStates()"\n                             class="mdi mdi-chevron-double-left icon-button pe-state-list-button">\n\n                            <span class="off-screen">Remove all states</span>\n                        </div>\n\n                        <div tabindex="0" title="Add All States" aria-label="Add All States"\n                             (click)="_addAllStates()"\n                             class="mdi mdi-chevron-double-right icon-button pe-state-list-button">\n\n                            <span class="off-screen">Add all states</span>\n                        </div>\n\n                    </div>-->\n                    <!--Button Block - Leftmost-->\n                    <div style="display:flex; flex-direction:column; margin-top:20px;">\n\n                        <div id="chevAddSelectedStatesAuthorize" tabindex="0" title="Add Selected States" aria-label="Add Selected States" role="button"\n                             class="mdi mdi-chevron-right icon-button pe-state-list-button"\n                             (click)="moveSelectedStates(_eGrid.unauthorized, _eGrid.authorized)"\n                             (keyup.enter)="moveSelectedStates(_eGrid.unauthorized, _eGrid.authorized)">\n                        </div>\n\n                        <div id="chevAddAllStatesAuthorize" tabindex="0" title="Add All States" aria-label="Add All States" role="button"\n                             class="mdi mdi-chevron-double-right icon-button pe-state-list-button"\n                             (click)="moveAllStates(_eGrid.unauthorized, _eGrid.authorized)"\n                             (keyup.enter)="moveAllStates(_eGrid.unauthorized, _eGrid.authorized)">\n                        </div>\n\n                        <div style="border-bottom:solid 1px #ccc; margin:5px;"></div>\n\n                        <div id="chevRemoveSelectedStatesAuthorize" tabindex="0" title="Remove Selected States" aria-label="Remove Selected States" role="button"\n                             class="mdi mdi-chevron-left icon-button pe-state-list-button"\n                             (click)="moveSelectedStates(_eGrid.authorized, _eGrid.unauthorized)"\n                             (keyup.enter)="moveSelectedStates(_eGrid.authorized, _eGrid.unauthorized)">\n                        </div>\n\n                        <div id="chevRemoveAllStatesAuthorize" tabindex="0" title="Remove All States" aria-label="Remove All States" role="button"\n                             class="mdi mdi-chevron-double-left icon-button pe-state-list-button"\n                             (click)="moveAllStates(_eGrid.authorized, _eGrid.unauthorized)"\n                             (keyup.enter)="moveAllStates(_eGrid.authorized, _eGrid.unauthorized)">\n                        </div>\n\n                    </div>\n\n                    <!--Right-->\n                    <cas-grid #authorizedStatesGrid\n                              summary="Authorized States List"\n                              [disabled]="(_fields.sec_authorized_states.read_only || _allFieldsDisabled) ? \'disabled\' : null"\n                              [settings]="_authorizedStates_gridSettings"></cas-grid>\n\n\n                    <ng-container *ngIf="this._new_practice">\n\n                        <!--Buttons Block - Rightmost-->\n                        <div style="display:flex; flex-direction:column; margin-top:20px;">\n\n                            <div id="chevAddSelectedStatesAdopt" tabindex="0" title="Add Selected States" aria-label="Add Selected States" role="button"\n                                 class="mdi mdi-chevron-right icon-button pe-state-list-button"\n                                 (click)="moveSelectedStates(_eGrid.authorized, _eGrid.adopted)"\n                                 (keyup.enter)="moveSelectedStates(_eGrid.authorized, _eGrid.adopted)">\n                            </div>\n\n                            <div id="chevAddAllStatesAdopt" tabindex="0" title="Add All States" aria-label="Add All States" role="button"\n                                 class="mdi mdi-chevron-double-right icon-button pe-state-list-button"\n                                 (click)="moveAllStates(_eGrid.authorized, _eGrid.adopted)"\n                                 (keyup.enter)="moveAllStates(_eGrid.authorized, _eGrid.adopted)">\n                            </div>\n\n                            <div style="border-bottom:solid 1px #ccc; margin:5px;"></div>\n\n                            <div id="chevRemoveSelectedStatesAdopt" tabindex="0" title="Remove Selected States" aria-label="Remove Selected States" role="button"\n                                 class="mdi mdi-chevron-left icon-button pe-state-list-button"\n                                 (click)="moveSelectedStates(_eGrid.adopted, _eGrid.authorized)"\n                                 (keyup.enter)="moveSelectedStates(_eGrid.adopted, _eGrid.authorized)">\n                            </div>\n\n                            <div id="chevRemoveAllStatesAdopt" tabindex="0" title="Remove All States" aria-label="Remove All States" role="button"\n                                 class="mdi mdi-chevron-double-left icon-button pe-state-list-button"\n                                 (click)="moveAllStates(_eGrid.adopted, _eGrid.authorized)"\n                                 (keyup.enter)="moveAllStates(_eGrid.adopted, _eGrid.authorized)">\n                            </div>\n\n                        </div>\n\n                        <!--Auto-Adopt-->\n                        <cas-grid #adoptedStatesGrid\n                                  summary="Adopted States List"\n                                  [disabled]="(_fields.sec_authorized_states.read_only || _allFieldsDisabled) ? \'disabled\' : null"\n                                  [settings]="_adoptedStates_gridSettings"></cas-grid>\n\n                    </ng-container>\n\n                </div>\n            </div>\n\n        </div>\n\n        <!-- Practice Name & Dates "Row"-->\n        <!-- ------------------------------------------------------------------------------------------------------------- -->\n        <div class="cpd-ui-row" style="padding: 10px 10px 10px 10px;" data-test-id="section_practice_name_dates">\n\n            <!--=====================================================================-->\n            <!-- Practice Name -->\n            <!--=====================================================================-->\n            <div id="gcPublish" class="cpd-ui-cell" style="flex-grow:1;">\n\n                <div id="ghdPublish" class="cpd-ui-group-lbl" role="heading" aria-level="3"><h3>Name / Publish</h3></div>\n\n                <!-- ---------------------------------------------------- -->\n                <!--practice_name (name)-->\n                <!-- ---------------------------------------------------- -->\n                <div class="cpd-ui-field-div" style="margin-top:12px;" [hidden]="!_fields.practice_name.show">\n                    <label for="practice_name" style="width:75px;">Name<span class="cpd-required" aria-label="required">*</span></label>\n                    <input id="practice_name" name="practice_name" type="text"\n                           data-cval-msg-element-id="practice_name_vmsg"\n                           data-cval-fld-name="Name"\n                           [attr.data-cval-required]="true"\n                           style="flex-grow:1;"\n                           class="cval {{ (_fields.practice_name.read_only || _allFieldsDisabled) ? \'cpd-ui-field-readonly\' : \'\'}}"\n                           (input)="_formChanged($event)"\n                           [attr.readonly]="(_fields.practice_name.field_read_only || _allFieldsDisabled) ? \'readonly\' : null"\n                           [attr.maxLength]="100"\n                           [ngModel]="_currentPractice?.practice_name" (ngModelChange)="_currentPractice.practice_name=$event" />\n                </div>\n\n                <!--validation message-->\n                <div id="practice_name_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n                <!-- ---------------------------------------------------- -->\n                <!--practice_display (short name)-->\n                <!-- ---------------------------------------------------- -->\n                <!--[pattern]="_fields_hash?.practice_display?.field_validation"-->\n                <div class="cpd-ui-field-div" [hidden]="!_fields.practice_display.show">\n                    <label for="practice_display" style="width:75px;">Short Name<span class="cpd-required" aria-label="required">*</span></label>\n                    <input id="practice_display" type="text" name="practice_display"\n                           data-cval-msg-element-id="practice_display_vmsg"\n                           data-cval-fld-name="Short Name"\n                           [attr.data-cval-required]="true"\n                           style="flex-grow:1;"\n                           class="cval {{ (_fields.practice_display.field_read_only || _allFieldsDisabled) ? \'cpd-ui-field-readonly\' : \'\'}}"\n                           (input)="_formChanged($event)"\n                           [attr.readonly]="(_fields.practice_display.field_read_only || _allFieldsDisabled) ? \'readonly\' : null"\n                           [attr.maxLength]="40"\n                           [ngModel]="_currentPractice?.practice_display" (ngModelChange)="_currentPractice.practice_display=$event" />\n                </div>\n\n                <!--validation message-->\n                <div id="practice_display_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n                <div style="display:flex;">\n                    <!-- ---------------------------------------------------- -->\n                    <!--publish-->\n                    <!-- ---------------------------------------------------- -->\n                    <div class="cpd-ui-field-div">\n\n                        <!--This odd solution is because there\'s not really a "readonly" for checkboxes\n                        We can\'t use disabled, because that creates a 508 issue (tabindexes)-->\n                        <label for="publish" style="width:75px;">Published</label>\n                        <input type="checkbox"\n                               *ngIf="(_fields.publish.read_only || _allFieldsDisabled || (this._prev_publish && !this._new_practice)) == false"\n                               id="publish" name="publish"\n                               (input)="_formChanged($event)"\n                               (click)="_formChanged($event)"\n                               [ngModel]="_currentPractice?.publish" (ngModelChange)="_currentPractice.publish=$event" />\n\n                        <input type="checkbox"\n                               *ngIf="(_fields.publish.read_only || _allFieldsDisabled || (this._prev_publish && !this._new_practice)) == true"\n                               id="publish" name="publish"\n                               onclick="return false;"\n                               role="application"\n                               aria-disabled="true"\n                               aria-label="Publish checkbox"\n                               [ngModel]="_currentPractice?.publish" />\n                    </div>\n\n                    <!-- ---------------------------------------------------- -->\n                    <!--start_date-->\n                    <!-- ---------------------------------------------------- -->\n                    <div class="cpd-ui-field-div" style="padding-left:25px;">\n\n                        <!--Notes: _now is not instantiated when this template first runs, so we supply a temporary value until it is-->\n                        <label for="start_date" style="width:100px; text-align:right;">Activation&nbsp;Date<span class="cpd-required" aria-label="required">*</span></label>\n                        <div class="cpd-ui-field-div">\n                            <input type="date"\n                                   [min]="_today"\n                                   placeholder="m/d/yyyy"\n                                   id="start_date"\n                                   name="start_date"\n                                   data-cval-msg-element-id="start_date_vmsg"\n                                   data-cval-fld-name="Activation Date"\n                                   [attr.data-cval-required]="true"\n                                   [attr.data-cval-date]="true"\n                                   style="width:140px;"\n                                   aria-label="Start date (format m/d/yyyy)"\n                                   class="form-control cval"\n                                   [attr.readonly]="(_fields.start_date.read_only || _allFieldsDisabled) ? \'readonly\' : null"\n                                   [ngModel]="_currentPractice?.start_date"\n                                   (ngModelChange)="_currentPractice.start_date=$event; _formChanged()" />\n\n                        </div>\n\n                    </div>\n\n                    <!-- ---------------------------------------------------- -->\n                    <!--sunset_date-->\n                    <!-- ---------------------------------------------------- -->\n                    <div class="cpd-ui-field-div" style="padding-left:25px;">\n                        <label for="sunset_date" style="width:75px; text-align:right;">Sunset&nbsp;Date</label>\n                        <div class="cpd-ui-field-div">\n                            <input type="date"\n                                   [min]="_today"\n                                   placeholder="m/d/yyyy"\n                                   [required]="false"\n                                   id="sunset_date"\n                                   name="sunset_date"\n                                   data-cval-msg-element-id="sunset_date_vmsg"\n                                   data-cval-fld-name="Sunset Date"\n                                   [attr.data-cval-date]="true"\n                                   style="width:140px;"\n                                   aria-label="Sunset date (format m/d/yyyy)"\n                                   class="form-control cval"\n                                   [attr.readonly]="(_fields.sunset_date.read_only || _allFieldsDisabled) ? \'readonly\' : null"\n                                   [ngModel]="_currentPractice?.sunset_date"\n                                   (ngModelChange)="_currentPractice.sunset_date=$event; _formChanged()" />\n\n                        </div>\n                    </div>\n\n\n                    <!-- ---------------------------------------------------- -->\n                    <!--end_date-->\n                    <!-- ---------------------------------------------------- -->\n                    <div class="cpd-ui-field-div" style="padding-left:25px;">\n                        <label for="end_date" style="width:55px; text-align:right;">End&nbsp;Date</label>\n                        <div class="cpd-ui-field-div">\n                            <input type="date"\n                                   [min]="_today"\n                                   placeholder="m/d/yyyy"\n                                   [required]="false"\n                                   id="end_date"\n                                   name="end_date"\n                                   data-cval-msg-element-id="end_date_vmsg"\n                                   data-cval-fld-name="End Date"\n                                   [attr.data-cval-date]="true"\n                                   style="width:140px;"\n                                   aria-label="End date (format m/d/yyyy)"\n                                   class="form-control cval"\n                                   [attr.readonly]="(_fields.end_date.read_only || _allFieldsDisabled) ? \'readonly\' : null"\n                                   [ngModel]="_currentPractice?.end_date"\n                                   (ngModelChange)="_currentPractice.end_date=$event; _formChanged()" />\n\n                        </div>\n                    </div>\n\n                    <!--validation message-->\n                    <div id="start_date_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                    <div id="sunset_date_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                    <div id="end_date_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n                </div>\n\n            </div>\n\n        </div>\n\n\n        <!-- Practice Definition "Row"-->\n        <!-- ------------------------------------------------------------------------------------------------------------- -->\n        <div class="cpd-ui-row" data-test-id="section_practice_edit_definition" style="padding: 10px 10px 20px 10px;">\n\n            <!--=====================================================================-->\n            <!-- Practice Definition -->\n            <!--=====================================================================-->\n            <div id="gcAssetDef" class="cpd-ui-cell" style="flex-grow:1;" [hidden]="!_fields.practice_definition.show">\n\n                <!-- ---------------------------------------------------- -->\n                <!--practice_definition-->\n                <!-- ---------------------------------------------------- -->\n                <!--[pattern]="_fields_hash?.practice_definition?.field_validation"-->\n                <div id="ghdAssetDef" class="cpd-ui-group-lbl" role="heading" aria-level="3"><h3>Asset&nbsp;Definition</h3></div>\n                <div class="cpd-ui-field-div" style="display: flex; align-items:flex-start; justify-content:flex-start;">\n                    <label for="practice_definition" style="margin-top:10px;width:115px;">Asset&nbsp;Definition<span class="cpd-required" aria-label="required">*</span></label>\n                    <textarea id="practice_definition"\n                              data-cval-msg-element-id="practice_definition_vmsg"\n                              data-cval-fld-name="Practice Definition"\n                              [attr.data-cval-required]="true"\n                              rows="6" style="flex-grow:1;" name="practice_definition"\n                              class="cval {{ (_fields.practice_definition.read_only || _allFieldsDisabled) ? \'cpd-ui-field-readonly\' : \'\'}}"\n                              (input)="_formChanged($event)"\n                              [attr.readonly]="(_fields.practice_definition.read_only || _allFieldsDisabled) ? \'readonly\' : null"\n                              [attr.maxLength]="2000"\n                              [ngModel]="_currentPractice?.practice_definition" (ngModelChange)="_currentPractice.practice_definition=$event"></textarea>\n                </div>\n\n                <!--validation message-->\n                <div id="practice_definition_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n            </div>\n\n        </div>\n\n        <!-- Narrative Description "Row"-->\n        <!-- ------------------------------------------------------------------------------------------------------------- -->\n        <div *ngIf="this._new_practice" class="cpd-ui-row" data-test-id="section_practice_edit_narrative_description" style="padding: 10px 10px 20px 10px;">\n\n            <!--=====================================================================-->\n            <!-- Default Narrative Section -->\n            <!--=====================================================================-->\n            <div id="gcNarrDesc" class="cpd-ui-cell" style="flex-grow:1;">\n\n                <!--Header for the section-->\n                <div id="ghdNarrDesc" class="cpd-ui-group-lbl" role="heading" aria-level="3"><h3>Default&nbsp;Narrative</h3></div>\n\n                <!-- ---------------------------------------------------- -->\n                <!-- narrative description -->\n                <!-- ---------------------------------------------------- -->\n                <div class="cpd-ui-field-div" style="display: flex; align-items:flex-start; justify-content:flex-start;">\n                    <label for="narrative_description" title="Default Description for the 00N Narrative created for this Asset" style="margin-top:10px;width:115px;">Narrative&nbsp;Description<span class="cpd-required" aria-label="required">*</span></label>\n                    <textarea id="narrative_description"\n                              data-cval-msg-element-id="narrative_description_vmsg"\n                              data-cval-fld-name="Narrative Description"\n                              [attr.data-cval-required]="true"\n                              rows="6" style="flex-grow:1;" name="narrative_description"\n                              placeholder="Default Description for the 00N Narrative created for this Asset"\n                              class="cval"\n                              (input)="_formChanged($event)"\n                              [attr.readonly]="null"\n                              [attr.maxLength]="2000"\n                              [ngModel]="_currentPractice?.narrative_description" (ngModelChange)="_currentPractice.narrative_description=$event"></textarea>\n                </div>\n\n                <!--validation message-->\n                <div id="narrative_description_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n            </div>\n\n        </div>\n\n    </div>\n\n    <!-- Popups -->\n    <!-- ------------------------------------------------------------------------------------------------------------- -->\n    <!--POPUP INSTANCE CONTAINER-->\n    <!--When the Modal component inserts the Angular component that wraps the Bootstrap popups, it needs to go somewhere\n    where it will be cleared when the user navigates away from this page.  Note that the popup elements inserted here\n    are moved to the \'body\' when displayed and then moved back here when not (so the heat shield/backdrop is under them in z-order).-->\n    <div id="practice_edit_v2_page_popups"></div>\n\n    <!-- Full Asset Type Business Rule Text Popup-->\n    <modal #businessRulePopup\n           containerId="practice_edit_v2_page_popups"\n           title="Current Asset Type Rules"\n           label="fullTextPopup">\n\n        <!--FVT-ID-->\n        <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_practice_edit_asset_type_rules"></section>\n\n        <!-- body -->\n        <section>\n            <table>\n                <caption class="off-screen">Current Asset Type Rules</caption>\n                <tr class="row" style="font-weight:bold;">\n                    <th class="col-2">Asset Code</th>\n                    <th class="col-2">Range/Starts With</th>\n                    <th class="col-8">Business Rule Description & Type</th>\n                </tr>\n                <ng-container *ngFor="let assetType of _businessRulesDisplay">\n                    <assetTypeRowModal [assetType]="assetType"></assetTypeRowModal>\n                </ng-container>\n            </table>\n        </section>\n\n        <!-- footer -->\n        <footer>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">OK</button>\n        </footer>\n    </modal>\n</div>\n\n\n\n\n<!--====================-->\n<!-- "Delete" Practice -->\n<!--====================-->\n<!-- dpp: "Delete Practice Popup" -->\n<!--<modal #deletePracticePopup\n       containerId="practice_edit_v2_page_popups"\n       title="Delete Asset"\n       label="deletePracticePopup">-->\n<!--FVT-ID-->\n<!--<section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_practice_edit_delete"></section>-->\n<!-- body -->\n<!--<section>\n\n    <div class="cpd-ui-row">\n\n        <div id="gcDelPopEndDate" class="cpd-ui-cell" style="width:100%">\n\n            <div id="ghdDelPopEndDate" class="cpd-ui-group-lbl" role="heading" aria-level="5"><h3>End Date</h3></div>\n\n            <div class="cpd-ui-field-div">\n                <label for="dpp_end_date" style="width:108px; text-align:right;">End&nbsp;Date<span class="cpd-required" aria-label="required">*</span></label>\n                <div class="cpd-ui-field-div">\n\n                    <input type="date"\n                           [min]="_today"\n                           [required]="true"\n                           placeholder="m/d/yyyy"\n                           id="dpp_end_date" name="dpp_end_date"\n                           style="width:140px;"\n                           class="form-control"\n                           aria-label="End date (format m/d/yyyy)"\n                           [attr.data-first-focus]="true"\n                           [ngModel]="_currentPractice?.end_date"\n                           (ngModelChange)="_currentPractice.end_date=$event; _formChanged($event)" />\n\n                </div>\n            </div>\n\n        </div>\n    </div>\n\n</section>-->\n\n<!-- footer -->\n<!--<footer>\n        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n        <button type="button"\n                [attr.disabled]="!_allFieldsDisabled ? null : \'disabled\'"\n                class="btn btn-primary"\n                (click)="_deletePractice();">\n            Delete\n        </button>\n\n    </footer>\n</modal>-->',
  styles : ['.pe-state-list{width:75px;height:80px;border:solid 1px #b8b8b8;padding:2px;overflow-y:auto;background-color:#f0f0f0}.pe-state-list-button{margin:0 5px;font-size:18px}.pe-cssClasses_Grid{border-bottom:none !important}.pe-cssClasses_Body{border:solid 1px #b8b8b8;border-radius:2px;background-color:#f0f0f0}.pe-cssClasses_Cell{padding:0 2px !important}.row{border-bottom:solid 1px #b8b8b8}'],
  providers:[],
  encapsulation: ViewEncapsulation.None //Allows child components to read the parent's styles
})
export class PracticesEditComponentV2 {

    
    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    @ViewChild('unauthorizedStatesGrid') unauthorizedStatesGrid; 
    @ViewChild('authorizedStatesGrid') authorizedStatesGrid;
    @ViewChild('adoptedStatesGrid') adoptedStatesGrid; 
    //@ViewChild('deletePracticePopup') deletePracticePopup;
    @ViewChild('businessRulePopup') businessRulePopup;
    
    //Growls
    //@Input('growlBoxContainerId') growlBoxContainerId;
	growlBox = null; //Class wide member reference for the growls control


    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    //"Enum" to make grid references a little easier
    _eGrid = {
        unauthorized: 1,
        authorized: 2,
        adopted: 3
    }

    _allFieldsDisabled = true;
    _assetTypeFilters = [{ practice_type_code_display: "", practice_type_code: "" }];
    _businessRulesDisplay = ""; //Used in Asset Type Business Rules text popup when "link" is clicked (captures all asset sreturned from _loadAssetTypes())
	_currentPracticeId = 0;
    _currentPractice = new Practice();
    _dirty = false; 
    _disposalFunctions = [];    //For disposing subscriptions to rxjs observables
    _measurements = [];         //Used to render select boxes of measurements
    _measurements_hash = {};    //Used for quick lookups against measurements (to find shapes)
    
    _new_practice = true;
    _practiceLoading = true;
    _selectedAssetTypeFilter = this._assetTypeFilters[0];
    _shapes_hash = {};
    _title = "";
    _valid = true;
    _isGreenhouseGas = false;

    //Feature Flags (Populated with the proper FF value during init)
    //_ff_climateSmartFeatureFlag = false;
    //_ff_DV1InsertAsset = false;
    //_ff_DV1UpdateAsset = false;

    //Flags
    _flag_FSAPractice = false;

    //Need to keep this until we replace all the refs below, otherwise we get nulls in many of the console logs
    _componentName = "PracticesEdit";

    //New
    //_formName = 'practices_edit'; //Just a shortcut (also helpful for cut & paste)
    //_forms = []; //Contains the form info and form fields associated with this view
    //_fields_hash = {}; //A hash of fields by field_name

    _fields = {}; //Replaces the fields_hash

    //Tracking previous values
    _prev_startDate = "";   //aka: activation date
    _prev_sunsetDate = "";     //aka: archival date
    _prev_endDate = "";     //aka: deletetion date
    _prev_publish = "";
    _now = moment();
    _today = new Date().toISOString().substring(0, 10);

    //Grids for state selection
    //  (the grid may be overkill but it gets me the functionality I need quickly without 
    //  needing to create new control or write lots of custom code to manage the lists)
    

    //Unauthorized grid
    _unauthorizedStates_gridSettings = {
        height:120, width:140, 
        multiSelect:true,
        showMessageWhenEmpty:false, 
        hideControlRow:true,
        rowIdentifyForJAWS: true,
        rowIdentityFieldForJAWS: "state_name_display",
        rowIdentityPrefixForJAWS: "State Name",
        cssClasses_Grid:"pe-cssClasses_Grid", 
        //cssClasses_Headers:"pe-cssClasses_Headers", 
        //cssClasses_ColumnHeaderRow:"pe-cssClasses_ColumnHeaderRow",
        cssClasses_Cell:"pe-cssClasses_Cell",
        cssClasses_Body:"pe-cssClasses_Body",
        columns:[{ fieldName:'state_name_display', display:'Unauthorized', width:'100%'}],
        rows:[]
    }

    //Authorized grid
    _authorizedStates_gridSettings = {
        height:120, width:140, multiSelect:true,
        showMessageWhenEmpty:false, hideControlRow:true,
        rowIdentifyForJAWS: true,
        rowIdentityFieldForJAWS: "state_name_display",
        rowIdentityPrefixForJAWS: "State Name",
        cssClasses_Grid:"pe-cssClasses_Grid", 
        //cssClasses_Headers:"pe-cssClasses_Headers", 
        //cssClasses_ColumnHeaderRow:"pe-cssClasses_ColumnHeaderRow",
        cssClasses_Cell:"pe-cssClasses_Cell", 
        cssClasses_Body:"pe-cssClasses_Body",
        columns:[{ fieldName:'state_name_display', display:'Authorized', width:'100%'}],
        rows:[]
    }

    //Authorized and Adopted Grid
    _adoptedStates_gridSettings = {
        height:120, width:180, multiSelect:true,
        showMessageWhenEmpty:false, hideControlRow:true,
        rowIdentifyForJAWS: true,
        rowIdentityFieldForJAWS: "state_name_display",
        rowIdentityPrefixForJAWS: "State Name",
        cssClasses_Grid:"pe-cssClasses_Grid", 
        //cssClasses_Headers:"pe-cssClasses_Headers", 
        //cssClasses_ColumnHeaderRow:"pe-cssClasses_ColumnHeaderRow",
        cssClasses_Cell:"pe-cssClasses_Cell", 
        cssClasses_Body:"pe-cssClasses_Body",
        columns:[{ fieldName:'state_name_display', display:'Authorize & Adopt', width:'100%'}],
        rows:[]
    }

    _pageUrl = '';

    // INITIALIZATION/LIFECYCLE METHODS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(    casNavBoxService:CASNavBoxService,
                    cpdFormatters: CPDFormatters,
                    changeDetectorRef: ChangeDetectorRef,
                    growlWrapperService: GrowlWrapperService,
                    helpers: Helpers,
                    route:ActivatedRoute,
                    router:Router,
                    webServices:WebServices,
                    featureFlagService: FeatureFlagService) {

        this.constructor.mapParams(this, arguments);

        this._pageURL = this.router.url;

        //Set default field values
        this._generateFieldPermissionHash(true);


        // Handle clicks on the NavBox actions
        //-------------------------------------------
        let disposer = casNavBoxService.OnActionClicked$.subscribe( action => {
            this._navBoxActionClicked(action);
        });
        this._disposalFunctions.push(disposer);


        // Debugging
        //-------------------------------------------
        /*
        casNavBoxService.ClearDebugEntries();
        //casNavBoxService.DebugEntries.push("zRoles Test");
        //casNavBoxService.DebugEntries.push("BC503");
        //casNavBoxService.DebugEntries.push("BC503_ERR");
        disposer = casNavBoxService.OnDebugEntryClicked$.subscribe( entry => {
            this._debugEntryClicked(entry);
        });
        this._disposalFunctions.push(disposer);
        */
        //console.log("=================================================================");
        //let _m = moment;
        //console.log("=================================================================");
        //debugger;
    };

    //==================================
    // ngOnInit
    //==================================
    ngOnInit(){

        console.log("\n[practicesEdit:ngOnInit()]------------------------------------------------------------------------");

        this.casNavBoxService.ActionsLoading = true;
        this.set508();
        this.runSyncInitializations(); //Run this before async init as it set up values for async init
        this.runAsyncInitializations();
    };

    //==================================
    // ngOnInit_Complete
    //==================================
    ngOnInit_Complete() {
        console.log("\n[practicesEdit:ngOnInit_Complete()]------------------------------------------------------------------------");
        this._loadData(() => { this.casValidate.initialize(true); });
    };

    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy(){
        for (var i=0; i<this._disposalFunctions.length; i++){
            this._disposalFunctions[i].unsubscribe();
        }
    };

    //==================================
    // runAsyncInitializations
    //==================================
    runAsyncInitializations() {

        let ops = 1;

        //Load the asset types
        this._loadAssetTypes(() => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });
    }

    //==================================
    // runSyncInitializations
    //==================================
    runSyncInitializations() {

		// Growl Prep
		this.growlBox = this.growlWrapperService.getGrowlBox("cpdesGrowlContainer");

        //Prep the validation object
        this.casValidate = new CASValidate(this);

        //Set up the nav box
        this.setNavBoxActions();

        //Load the field permisisons
        //this._generateFieldPermissionHash();

        //Set initial, default page state (Add/Edit)
        if (this.route.snapshot.params.practiceId) {
            this._new_practice = false;
        }
    }



    // UI MANAGEMENT FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // assetFilterChanged
    //==================================
    assetFilterChanged(e) {
        let assetTypeCode = this._selectedAssetTypeFilter.practice_type_code;

        this._loadAssetTypeFields(assetTypeCode).then(() => {
            this._formChanged();
        });
    }

    //==================================
    // set508
    //==================================
    set508() {
        window.setTimeout(() => {
            let el = document.getElementsByClassName("cpd-title-div")[0];
            if (el) { el.focus(); }
        }, 0);
    }

    //==================================
    // setNavBoxActions
    //==================================
    setNavBoxActions() {
        let actions = [];

        switch (authToken.user.role) {
            case Enums.Roles.NHQNationalPracticeDataSteward.id:
                actions.push(new FormAction("act_close_practice", "Close Asset"));
                //actions.push(new FormAction("act_delete_practice", "Delete Asset")); //BASECAMP-862
                actions.push(new FormAction("act_new_practice", "New Asset"));
                actions.push(new FormAction("act_save_practice", "<u>S</u>ave Asset", true, null, "s"));
                break;

            case Enums.Roles.StateDataSteward.id:
            case Enums.Roles.NationalDisciplineDataSteward.id:
            case Enums.Roles.DataViewer.id:
                actions.push(new FormAction("act_close_practice", "Close Asset"));
                break;
        }
        actions.push(new FormAction("act_export_practice", "Export Asset"));

        if (this.router.url.startsWith(this._pageURL)) {
            this.casNavBoxService.Actions = actions;
        }
    }

   //==================================
    // _disableUI
    //==================================
    // Disable all UI controls, including the navBox.
    _disableUI(){
        this.casNavBoxService.DisableAllLinks();
        this._allFieldsDisabled = true;
    };

    //==================================
    // _enableUI
    //==================================
    // Enable all UI controls, including the navBox.
    _enableUI(){
        this.casNavBoxService.EnableAllLinks();
        if (authToken.user.role == Enums.Roles.NHQNationalPracticeDataSteward.id) {
            this._allFieldsDisabled = false;
        }
    };

    //==================================
    // _formChanged
    //==================================
    _formChanged(event){
        // Trigger change detection for DOM changes. This keeps the validation in sync when we show and
        // hide inputs using *ngIf. Otherwise, the validation still sees hidden inputs and doesn't see the 
        // newly shown inputs. It lags one event behind what's actually happening without it.
        this.changeDetectorRef.detectChanges();

        //Mark the form dirty if it isn't already
        if (!this._dirty){
            this._setPracticeDirty();
        }

        //Check the form's validity
        let isValid = this.casValidate.isAllValid(true, "pe_main_content_div");
        if (isValid){
            if (!this._valid){ 
                this._setPracticeValid();
            }
        }
        else{
            //Form is invalid
            if (this._valid){ 
                this._setPracticeInvalid();
            }
        }
    };

    //==================================
    // _getFieldPermissions
    //==================================
    // Builds an object indicating how fields should be rendered in the
    // markup based on the user's role.  This replaces the form-fields DB tables.
    // bDefault<bool>:      //(opt, false) When true, all fields will be set to no-access to allow for view binding without a million ngIfs
    //                      // (also allows tests to work more easily)
    _generateFieldPermissionHash(bDefault) {

        //Short circuit for default values
        if (bDefault) {
            this._fields.assetTypes = new FormField(false, false);
            this._fields.effect_measurement_unit_id = new FormField(false, false);
            this._fields.end_date = new FormField(false, false);
            this._fields.impact_measurement_unit_id = new FormField(false, false);
            this._fields.installed_practice_lifespan_years = new FormField(false, false);
            this._fields.measurement_unit_id = new FormField(false, false);
            this._fields.practice_code = new FormField(false, false);
            this._fields.practice_definition = new FormField(false, false);
            this._fields.practice_display = new FormField(false, false);
            this._fields.practice_name = new FormField(false, false);
            this._fields.publish = new FormField(false, false);
            this._fields.replacement_code = new FormField(false, false);
            this._fields.reporting_code = new FormField(false, false);
            this._fields.reporting_measurement_unit_id = new FormField(false, false);
            this._fields.sec_authorized_states = new FormField(false, false);
            this._fields.shape_type = new FormField(false, false);
            this._fields.start_date = new FormField(false, false);
            this._fields.sunset_date = new FormField(false, false);
            return;
        }

        //FormField        
        switch (authToken.user.role) {

            //Roles with READ access
            case Enums.Roles.DataViewer.id: // FormField (read_only, show)
            case Enums.Roles.NationalDisciplineDataSteward.id:
            case Enums.Roles.StateDataSteward.id:
                this._fields.assetTypes = new FormField(true, true);
                this._fields.effect_measurement_unit_id = new FormField(true, false);
                this._fields.end_date = new FormField(true, true);
                this._fields.impact_measurement_unit_id = new FormField(true, false);
                this._fields.installed_practice_lifespan_years = new FormField(true, true);
                this._fields.measurement_unit_id = new FormField(true, true);
                this._fields.practice_code = new FormField(true, true);
                this._fields.practice_definition = new FormField(true, true);
                this._fields.practice_display = new FormField(true, true);
                this._fields.practice_name = new FormField(true, true);
                this._fields.publish = new FormField(true, true);
                this._fields.replacement_code = new FormField(true, true);
                this._fields.reporting_code = new FormField(true, true);
                this._fields.reporting_measurement_unit_id = new FormField(true, false);
                this._fields.sec_authorized_states = new FormField(true, true);
                this._fields.shape_type = new FormField(true, true);
                this._fields.start_date = new FormField(true, true);
                this._fields.sunset_date = new FormField(true, true);
                break;

            //Roles with READ & WRITE access
            case Enums.Roles.NHQNationalPracticeDataSteward.id:
                this._fields.assetTypes = new FormField(false, true);
                this._fields.effect_measurement_unit_id = new FormField(true, false);
                this._fields.end_date = new FormField(false, true);
                this._fields.impact_measurement_unit_id = new FormField(true, false);
                this._fields.installed_practice_lifespan_years = new FormField(false, true);
                this._fields.measurement_unit_id = new FormField(false, true);
                this._fields.narrative_description = new FormField(false, true);
                this._fields.practice_code = new FormField(false, true);
                this._fields.practice_definition = new FormField(false, true);
                this._fields.practice_display = new FormField(false, true);
                this._fields.practice_name = new FormField(false, true);
                this._fields.publish = new FormField(false, true);
                this._fields.replacement_code = new FormField(false, false);
                this._fields.reporting_code = new FormField(false, true);
                this._fields.reporting_measurement_unit_id = new FormField(true, false);
                this._fields.sec_authorized_states = new FormField(false, true);
                this._fields.shape_type = new FormField(true, true);
                this._fields.start_date = new FormField(false, true);
                this._fields.sunset_date = new FormField(false, true);
                break;

            default:
                this.growlBox.addGrowl("error", "Current role does not have any data for accessing this form");
                throw("Current role does not have any data for accessing this form");
        }

        console.log("fieldHash(): this._fields:", this._fields);

    }

    //==================================
    // isFSAAssetType
    //==================================
    isFSAAssetType(flag) {

        return this.helpers.containsFlag(flag, Enums.ATCFlags.FSA_PRACTICE)
    };

    //==================================
    // _setPracticeClean
    //==================================
    _setPracticeClean(){
        this._dirty = false;
        this.casValidate.markAllValid("pe_main_content_div");
    };

    //==================================
    // _setPracticeDirty
    //==================================
    _setPracticeDirty(){
        this._dirty = true;
    };

    //==================================
    // _setPracticeInvalid
    //==================================
    _setPracticeInvalid() {
        this._valid = false;
    };
    
    //==================================
    // _setPracticeValid
    //==================================
    _setPracticeValid() {
        this._valid = true;
    };


    // LOGIC FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //BASECAMP-862
    ////==================================
    //// _deletePractice
    ////==================================
    //_deletePractice(){

    //    if (!this._currentPractice.end_date) {
    //        alert("Please supply an end date");
    //        return;
    //    }

    //    //Disable the form and navbox while deleting
    //    this._disableUI();
    //    this.growlBox.addGrowl("info", "Deleting record...");

    //    console.log("[practicesEdit:_deletePractice()] - calling Delete, this._currentPractice:", this._currentPractice);

    //    //Convert the dateStruct
    //    let endDate = this._currentPractice.end_date ? new Date(this._currentPractice.end_date).toISOString() : null;


    //    //Call the delete
    //    this.webServices.DeletePractice(this._currentPractice.practice_id, endDate )
    //    .then((res) => { 

    //        console.log("[practicesEdit:_deletePractice() - res:]", res); 

    //        //Check for validation errors
    //        if (res.Success){

    //            this.growlBox.addGrowl("success", "Record updated.  Redirecting...");

    //            //redirect so the URL is correct and we reload the page
    //            this._enableUI();
    //            this.router.navigate(["/cpdes/practices/viewV2"]);

    //        }
    //        else{
    //            if (res.ValidationErrors.length > 0){
    //                this.growlBox.addGrowl("error", "There were validation errors: " + this.cpdFormatters.formatValidationErrors(res.ValidationErrors));
    //            }
    //            else{
    //                this.growlBox.addGrowl("error", "An error occured while saving: " + this.cpdFormatters.formatError(res));
    //            }

    //            this._enableUI();
    //        }

    //        this.deletePracticePopup.Close();
    //    })
    //    .catch((err)=>{
    //        console.log("[practicesEdit:_deletePractice() - err:]", err);
    //        this._enableUI();
    //        this.growlBox.addGrowl("error", "An error occured while saving: " + this.cpdFormatters.formatError(err));
    //    })
        
    //};

    //==================================
    // _getShapeType
    //==================================
    _getShapeType(){

        if (!this._currentPractice){ return ""; }

        var unitId = this._currentPractice.measurement_unit_id;

        //Jump out if no measurement is set
        if (!unitId){ return ""; }
        
        //Break it down so its easier to follow
        let measurement = this._measurements_hash[unitId];
        if (!measurement){ return ""; }

        let shape = this._shapes_hash[measurement.shape_type_id];
        if (!shape){ return ""; }

        return shape.shape_type;
    };

    //==================================
    // _getUnitDisplay
    //==================================
    _getUnitDisplay(measurement_unit_id) {
        if (!measurement_unit_id) { return ""; }
        return this._measurements_hash[measurement_unit_id].measurement_unit_name;
    }
    
    //==================================
    // _dv1_insertNewPractice
    //==================================
    _dv1_insertNewPractice(){

        this._disableUI();
        this.growlBox.addGrowl("info", "Saving new record...");

        // Process practice
        //---------------------------
        // Need to preprocess the paractice before submitting (date fields are a bootstrap structure)
        var practice = this._prepPracticeForSave(this._currentPractice);


        // Call Service
        //---------------------------
        this.webServices.Post("/practices/dv1_InsertNewPractice", practice )
            .then(res => {

                console.log(`[${this._componentName}:_dv1_insertNewPractice()] - res: `, res);

                //Check for validation errors
                if (res.Success){
                    this.growlBox.addGrowl("success", "Record Saved.  Redirecting...");

                    //redirect so the URL is correct and we reload the page
                    let newPracticeId = res.DTO.practice_id;
                    this._enableUI();
                    this.router.navigate(["/cpdes/practices/editV2/" + newPracticeId]);
                }
                else{
                    switch (res.ErrorCode) {

                        //This one shouldn't happen if client side validation is working properly.
                        case "ERR-PBL-INP1":
                            this.growlBox.addGrowl("error", "Narrative description is required.");
                            break;

                        case "ERR-PBL-INP2":
                            this.growlBox.addGrowl("error", "Provided Practice Code is already in use.");
                            break;

                        //This one shouldn't happen if client side validation is working properly.
                        case "ERR-PBL-PNP1":
                            this.growlBox.addGrowl("error", "Invalid data provided.  Please verify form data.");
                            break;

                        case "ERR-PBL-PNPS1":
                            this.growlBox.addGrowl("error", "Invalid data provided.  Please verify form data.");
                            break;

                        case "ERR-PBL-RPIRPLC2":
                            this.growlBox.addGrowl("error", "Replacement code must be different than the assets's practice code");
                            break;

                        case "ERR-PBL-RPIRPLC3":
                            this.growlBox.addGrowl("error", "Provided Replacement Code not found.");
                            break;

                        case "ERR-PBL-SRPI2":
                            this.growlBox.addGrowl("error", "Provided Reporting Code not found.");
                            break;

                        case "ERR-EC-SE1":
                            this.growlBox.addGrowl("warn", "No email subject provided.");
                            break;

                        case "ERR-EC-SE2":
                            this.growlBox.addGrowl("warn", "No email message provided.");
                            break;

                        case "ERR-EC-SE3":
                            this.growlBox.addGrowl("warn", "Error sending email message. Mailbox busy or unavailable.");
                            break;

                        case "ERR-EC-SE4":
                            this.growlBox.addGrowl("warn", "Failed sending mail to recipient.");
                            break;

                        case "ERR-EC-SE5":
                            this.growlBox.addGrowl("warn", "Error sending email message: " + res.ErrorMessage);
                            break;

                        case "ERR-EC-SE6":
                            this.growlBox.addGrowl("warn", "Error finding or reading email template.");
                            break;

                        case "ERR-ZU-GSDS1":
                            this.growlBox.addGrowl("warn", "Unable to get State Data Steward info from ZRoles for state: {state}.");
                            break;

                        default:
                            this.growlBox.addGrowl("error", res.ErrorMessage);
                    }

                    this._enableUI();
                }
            })
            .catch(err => {
                this.growlBox.addGrowl("error", "There was an error saving the asset");
                console.log(this.cpdFormatters.formatError(err));
                this._enableUI();
            })

            this._enableUI();
    };

    ////==================================
    //// _insertPractice
    ////==================================
    //_insertPractice(){

    //    //Disable the form and navbox while saving
    //    this._disableUI();
    //    this.growlBox.addGrowl("info", "Saving new record...");

    //    console.log("[practicesEdit:_insertPractice()] - calling Post, this._currentPractice:", this._currentPractice); 

    //    // Process practice
    //    //---------------------------
    //    // Need to preprocess the paractice before submitting (date fields are a bootstrap structure)
    //    var practice = this._prepPracticeForSave(this._currentPractice);

    //    //Service does not expect a practice_id for inserts
    //    //delete practice.practice_id;

    //    //Insert the new record
    //    this.webServices.InsertPractice(practice)
    //    .then((res) => { 

    //        console.log("[practicesEdit:_insertPractice() - res:]", res); 

    //        //Check for validation errors
    //        if (res.Success){
    //            this.growlBox.addGrowl("success", "Record Saved.  Redirecting...");

    //            //redirect so the URL is correct and we reload the page
    //            let newPracticeId = res.DTO.practice_id;
    //            this._enableUI();
    //            this.router.navigate(["/cpdes/practices/editV2/" + newPracticeId]);
    //        }
    //        else{
    //            if (res.ValidationErrors.length > 0){
    //                this.growlBox.addGrowl("error", "There were validation errors: " + this.cpdFormatters.formatValidationErrors(res.ValidationErrors));
    //            }
    //            else{
    //                this.growlBox.addGrowl("error", "An error occured while saving: " + this.cpdFormatters.formatError(res));
    //            }

    //            this._enableUI();
    //        }
    //    })
    //    .catch((err)=>{
    //        console.log("[practicesEdit:_insertPractice() - err:]", err);
    //        this._enableUI();
    //        this.growlBox.addGrowl("error", "An error occured while saving: " + this.cpdFormatters.formatError(err));
    //    })
    //};

    //==================================
    // _loadAssetTypeFields
    //==================================
    _loadAssetTypeFields(assetTypeCode) {

        return new Promise((resolve, reject) => {
            this.webServices.Get({
                apiPath: "/practices/getPracticeTypeCode",
                args: {
                    fy: null,
                    assetTypeCode: assetTypeCode
                }
            })
                .then(res => {
                    console.log("[{0}:/practices/getPracticeTypeCode] - res:".format(this._componentName), res);
                    let dto = res.data.DTO;

                    //Errors in the callback trigger the catch for this service call (?!) and populate the alerts with errors the user shouldn't see.  Catch it here instead.
                    if (assetTypeCode) {
                        try {

                            //Populate Asset Type and description fields
                            this._currentPractice.practice_type_code = dto.practice_type_code;
                            this._currentPractice.practice_type_code_description = dto.practice_type_code_description;
                            this._currentPractice.business_rule_description = dto.business_rule_description;
                            this._currentPractice.business_rule_range = dto.business_rule_range;
                            this._currentPractice.business_rule_starts_with = dto.business_rule_starts_with;
                            this._selectedAssetTypeFilter = this._assetTypeFilters[this._assetTypeFilters.findIndex((assetTypeFilter) => assetTypeFilter.practice_type_code == dto.practice_type_code)];
                            this._flag_FSAPractice = this.isFSAAssetType(dto.attribute_flags);
                        }
                        catch (err) {
                            this.growlBox.addGrowl("error", "An unexpected error has occurred");
                            console.log("[ERROR][{0}:assetFilterChanged()]".format(this._componentName), err);
                        }
                    }
                    else {
                        this._currentPractice.practice_type_code = null;
                        this._currentPractice.practice_type_code_description = null;
                        this._currentPractice.business_rule_description = null;
                        this._currentPractice.business_rule_range = null;
                        this._currentPractice.business_rule_starts_with = null;
                        this._flag_FSAPractice = false;
                    }
                    resolve();

                })
                .catch(err => {
                    this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));

                });
        });

    };

    //==================================
    // _loadAssetTypes
    //==================================
    _loadAssetTypes(fnOnSuccess, fnOnError) {

        this.webServices.Get({
            apiPath: "/practices/getPracticeTypeCodes",
            args: {
                fy: null,
                includeAll: false
            }
        })
            .then(res => {
                console.log("[{0}:/practices/getPracticeTypeCodes] - res:".format(this._componentName), res);
                let dto = res.data.DTO;
                this._businessRulesDisplay = dto;

                //Errors in the callback trigger the catch for this service call (?!) and populate the alerts with errors the user shouldn't see.  Catch it here instead.
                try {

                    //Build the asset types list
                    this._assetTypeFilters = [{ practice_type_code_display: "", practice_type_code: "" }].concat(dto);
                    this._selectedAssetTypeFilter = this._assetTypeFilters[0];

                    if (fnOnSuccess) { fnOnSuccess(dto); }
                }
                catch (err) {
                    this.growlBox.addGrowl("error", "An unexpected error has occurred");
                    console.log("[ERROR][{0}:_loadAssetTypes()]".format(this._componentName), err);
                    if (fnOnError) { fnOnError(); }
                }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));

                if (fnOnError) { fnOnError(); }
            });

    }

    //==================================
    // _loadComplete
    //==================================
    _loadComplete(callback){

        console.log("------------------_loadComplete------------------");

        //Now that we have the current practice's states AND the form fields, we can populate the states lists
        //------------------------------------------------------------
        this._populateStates$().then(()=>{
            //Removes loading indicator and puts the fields back on the screen
            this._practiceLoading = false;
            this._enableUI();

            console.log("------------------States Populated ------------------");

            //I don't like Angular
            setTimeout(()=>{ 
                //In some cases this still fails as Angular still hasn't assigned the grid variable
                //Look into putting it in onAfterInit
                this.authorizedStatesGrid.SortGrid("state_name_display", "A");
                this.unauthorizedStatesGrid.SortGrid("state_name_display", "A");
            } ,0);

        });

        //Set title (In the future, we probably want to add this to the link between forms & roles in the DB)
        switch(authToken.user.role){

            //National
            case Enums.Roles.NHQNationalPracticeDataSteward.id:
                this._title = this._new_practice ? "Add Asset" : "Edit Asset";
                break;

            default:
                this._title = "View Asset";
                break;
        }

        setTimeout(() => {
            this._refreshActionLinks();
            if (callback){ callback(); }
        }, 0);

    };

    //==================================
    // _loadData
    //==================================
    _loadData(callback){

        let serviceCalls = 3;

        //Disable the UI for loading (disables fields and navBox)
        this._disableUI();

        //Set the practice loading flag (which actually hides the fields and shows a loading indicator)
        this._practiceLoading = true;


        // Load Practice
        //-----------------------------
        this.route.params.pipe(
            switchMap((params) => {
                this._currentPracticeId = +params["practiceId"];

                return new Promise((resolve, reject)=>{
                    
                    //New Practice?
                    if (isNaN(this._currentPracticeId) || !this._currentPracticeId) {
                        this._new_practice = true;
                        //resolve({ data:new Practice() });
                        resolve(new Practice());
                    }
                    else {

                        //Existing practice, load it
                        this.webServices.Get({
                            apiPath: "/practices/getPractice",
                            args: { practiceId: this._currentPracticeId }
                        })
                        .then(res => {
                            console.log("[{0}:_loadData():/practices/getPractice] - res:".format(this._componentName), res);
                            if (res.data.Success) { resolve(res.data.DTO); }
                            else { reject(res.data.ErrorMessage); }
                        })
                        .catch(err => {
                            reject(err);
                        });

                    }
                });
           }))
        .subscribe(
        
            //All Good
            (res) => {
                console.log("[practicesEdit:_loadData()] res (get or default):", res);
                
                //If the indicated id isn't found, just return to the main list
                if (!res){
                    this.router.navigate(["/cpdes/practices/viewV2"]);
                }

                //Format response data before assigning it to our local model 
                //------------------------------------------------------------
                let practice = res;

                //Start Date
                //practice.start_date = this.cpdFormatters.formatDateString(practice.start_date);
                //practice.start_date = this.cpdFormatters.dateStringToDate(practice.start_date);
                practice.start_date = practice.start_date ? new Date(practice.start_date).toISOString().substring(0, 10) : null;
                this._prev_startDate = practice.start_date;

                //Sunet Date
                practice.sunset_date = practice.sunset_date ? new Date(practice.sunset_date).toISOString().substring(0, 10) : null;
                this._prev_sunsetDate = practice.sunset_date;
                
                //End Date
                //practice.end_date = this.cpdFormatters.formatDateString(practice.end_date);
                practice.end_date = practice.end_date ? new Date(practice.end_date).toISOString().substring(0, 10) : null;
                this._prev_endDate = practice.end_date;

                //the publish "boolean" is stored as a char(1) in the DB using 'Y' and 'N' for its values (*sigh*)
                practice.publish = (practice.publish && practice.publish.toUpperCase() == 'Y') ? true : false;
                this._prev_publish = practice.publish;

                //let assetTypeCode = (!practice.practice_type_code ? "" : practice.practice_type_code);
                //Assign data to model
                this._currentPractice = practice;

                //Asset Type Code
                this._loadAssetTypeFields(practice.practice_type_code);

                //Flag the service complete
                if (--serviceCalls == 0) { this._loadComplete(callback); }
            },

            //Error
            (err) => {
                //this.growlBox.addGrowl("error", err.message || "An unexpected error has occurred");
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                console.log("[practicesEdit:_loadData():(_currentPracticeId:" + this._currentPracticeId + ")]:", err);
                this._enableUI();
            }
        );
        
        // Load Measurements
        //-----------------------------
        this.webServices.Get({
            apiPath: "/measurement/getMeasurementUnits"
        })
        .then(res => {
            console.log("[{0}:/measurement/getMeasurementUnits] - res:".format(this._componentName), res);

            if (res.data.Success) {

                let dto = res.data.DTO;

                //Manage errors locally
                try {
                    this._measurements =
                    [{
                        measurement_unit_id: null,
                        measurement_unit_display: "Select Unit",
                        measurement_unit_name: "Select Unit",
                        shape_type_id: 0 
                    }]
                    .concat(dto);

                    //Make a hash from the units
                    this._measurements_hash = dto.reduce((prev, cur) => { prev[cur.measurement_unit_id] = cur; return prev; }, {});

                    //Check for completion os all service calls
                    if (--serviceCalls == 0) { this._loadComplete(callback); }
                }
                catch (err) {
                    this.growlBox.addGrowl("error", "An unexpected error has occurred (check console for details)");
                    console.log("[ERROR][practicesEdit:_loadData():/measurement/getMeasurementUnits]", err);
                }
            }
            else {
                this.growlBox.addGrowl("error", res.data.ErrorMessage);
            }
        })
        .catch(err => {
            this.growlBox.addGrowl("error", "An unexpected error has occurred");
            console.log("[ERROR][practicesEdit:_loadData():/measurement/getMeasurementUnits]", this.cpdFormatters.formatError(err));
        });


        // Load Shapes
        //-----------------------------
        this.webServices.Get({
            apiPath: "/measurement/getShapes"
        })
        .then(res => {
            console.log("[{0}:/measurement/getShapes] - res:".format(this._componentName), res);

            if (res.data.Success) {

                let dto = res.data.DTO;

                //Manage errors locally
                try {
                    this._shapes_hash = dto.reduce((prev, cur) => { prev[cur.shape_type_id] = cur; return prev; }, {});
                    if (--serviceCalls == 0) { this._loadComplete(callback); }
                }
                catch (err) {
                    this.growlBox.addGrowl("error", "An unexpected error has occurred (check console for details)");
                    console.log("[ERROR][practicesEdit:_loadData():/measurement/getShapes]", err);
                }
            }
            else {
                this.growlBox.addGrowl("error", res.data.ErrorMessage);
            }
        })
        .catch(err => {
            this.growlBox.addGrowl("error", "An unexpected error has occurred");
            console.log("[ERROR][practicesEdit:_loadData():/measurement/getShapes]", this.cpdFormatters.formatError(err));
        });        

    };

    //==================================
    // _loadFeatureFlags
    //==================================
    _loadFeatureFlags(fnOnComplete) {

        //Get Feature Flags in bulk        
        this.featureFlagService.getFeatureFlags()
            .then(res => {
                
                //Grab the ffs
                //this._ff_climateSmartFeatureFlag = !!res.find(ff => ff.KeyName == Enums.FeatureFlags.ClimateSmart);
                //this._ff_DV1InsertAsset = !!res.find(ff => ff.KeyName == Enums.FeatureFlags.DV1InsertAsset);
                //this._ff_DV1UpdateAsset = !!res.find(ff => ff.KeyName == Enums.FeatureFlags.DV1UpdateAsset);

                if (fnOnComplete) { fnOnComplete(); }

                //console.log("=====================================");
                //console.log("_ff_climateSmartFeatureFlag:", this._ff_climateSmartFeatureFlag);
                //console.log("_ff_DV1InsertAsset:", this._ff_DV1InsertAsset);
                //console.log("_ff_DV1UpdateAsset:", this._ff_DV1UpdateAsset);
                //console.log("=====================================");
            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError("Feature Flag Load Failed"));
                console.log(err);
            });
        
    }

    //==================================
    // moveAllStates
    //==================================
    moveAllStates(eGridFrom, eGridTo) {

        //Jump out if this operation should currently not be executed
        if (this._allFieldsDisabled){ return; }
        if (this._fields.sec_authorized_states && this._fields.sec_authorized_states.read_only){ return; }

        //Grab a reference to the grid settings we are working with
        //Grab a reference to the grids we are working with
        let fromGrid = this.eGridToGrid(eGridFrom);
        let toGrid = this.eGridToGrid(eGridTo);

        //Get buffer references to the array for off screen work
        var arrSource = fromGrid.settings.rows;
        var arrDest = toGrid.settings.rows;
        
        //Clear the display while we work by clearing the grid references to the array in memory
        fromGrid.settings.rows = [];
        toGrid.settings.rows = [];

        //Let the UI render before moving on (this might be a little overkill given the small data size)
        window.setTimeout(() => {
            finishProcessing();
        }, 0);

        //------------------------------
        // finishProcessing
        //------------------------------
        let finishProcessing = ()=> {

            //Move the states in the buffer arrays
            //  (not using concat because there's no need to waste time on making new arrays)
            //  (not using push.apply() because I'd rather not risk playing with maximum paramter list sizes)
            while(arrSource.length > 0){
                arrDest.push(arrSource.splice(0,1)[0]);
            }

            //Sort the populated array
            this._sortStateData(arrDest);
        
            //Assign the array back to the populated list
            toGrid.settings.rows = arrDest;

            //Make sure the pushed row isn't flagged as selected
            toGrid.component.UnselectAllRows();

            //Update the practice's authorized states list
            this._syncPracticeToStatesList();
        }

    }

    //==================================
    // moveSelectedStates
    //==================================
    moveSelectedStates(eGridFrom, eGridTo) {

        //Jump out if this operation should currently not be executed
        if (this._allFieldsDisabled){ return; }
        if (this._fields.sec_authorized_states && this._fields.sec_authorized_states.read_only){ return; }

        //Grab a reference to the grids we are working with
        let fromGrid = this.eGridToGrid(eGridFrom);
        let toGrid = this.eGridToGrid(eGridTo);

        //Get buffer references to the array for off screen work
        var arrSource = fromGrid.settings.rows;
        var arrDest = toGrid.settings.rows;

        //Cycle through the selected, source rows and move them to the destination
        //(from high to low to avoid corrupting the indexes)
        let selectedRowIndexes = fromGrid.component.GetSelectedRowsIndexes().sort((a, b) => b - a); //Sort as number desc
        selectedRowIndexes.forEach((idx) => {
            let row = arrSource.splice(idx,1)[0];
            arrDest.push(row);
        });
        
        //Make sure the pushed row isn't flagged as selected
        toGrid.component.UnselectAllRows();

        //Resort the receiving list
        this._sortStateData(arrDest);

        //Update the practice's authorized states list
        this._syncPracticeToStatesList();
    }

    //==================================
    // _navBoxActionClicked
    //==================================
    _navBoxActionClicked(action){
        if (!action.__enabled){ return; }

        switch(action.field_name.toLowerCase()){
            
            // CLOSE PRACTICE
            //--------------------------------------
            case "act_close_practice":
                this.router.navigate(["/cpdes/practices/viewV2"]);
                break;
            

            // DELETE PRACTICE
            //--------------------------------------
            //BASECAMP-862
            //case "act_delete_practice":
            //    this._showDeletePracticePopup();
            //    break;


            // NEW PRACTICE
            //--------------------------------------
            case "act_new_practice":
                this.router.navigate(["/cpdes/practices/editV2"]);
                break;


            // REPLACE PRACTICE
            //--------------------------------------
            case "act_replace_practice":
                console.log("[practicesEdit:_navBoxActionClicked()] Action code not implemented:", action);
                break;


            // SAVE PRACTICE
            //--------------------------------------
            case "act_save_practice":

                //Validate action first
                if (!this._valid) {
                    this.growlBox.addGrowl("error", "The form is not valid. Please complete all required fields and resolve any errors.");
                    document.getElementById('cpd_content_div').scrollTop = 0;
                    return;
                }

                if (!this._dirty){
                    this.growlBox.addGrowl("error", "No changes have been detected.");
                    document.getElementById('cpd_content_div').scrollTop = 0;
                    return;
                }

                if (this._currentPractice.end_date && this._currentPractice.sunset_date && this._currentPractice.end_date < this._currentPractice.sunset_date) {
                    this.growlBox.addGrowl("error", "End Date must be after Sunset Date.");
                    document.getElementById('cpd_content_div').scrollTop = 0;
                    return;
                }

                if (this._currentPractice.start_date && this._currentPractice.sunset_date && this._currentPractice.sunset_date < this._currentPractice.start_date) {
                    this.growlBox.addGrowl("error", "Sunset Date must be after Start Date.");
                    document.getElementById('cpd_content_div').scrollTop = 0;
                    return;
                }

                if (this._currentPractice.publish && !this._prev_publish && !this._new_practice) {
                    alert("The narrative associated to this asset did not automatically publish. Please be sure to manually publish the narrative to complete the work.");
                }

                if (this._prev_endDate != this._currentPractice.end_date) {
                    alert("Edits to this Asset's End Date are being saved.  Please also review the End Dates of any of the Narratives associated with this Asset.  Reminder: an End-Dated Asset should not have any active narratives.");
                }

                //Insert or Update?
                if (this._new_practice){
                    this._dv1_insertNewPractice();
                }
                else {
                    this._dv1_updatePractice();
                }

                
                break;

            // EXPORT PRACTICE
            //-------------------------------------------
            case "act_export_practice":
                this._exportPractice();
                break;

            default:
                console.log("[practicesEdit:_navBoxActionClicked()] Unsupported action:", action);
        }

    };

    //==================================
    // _populateStates$
    //==================================
    _populateStates$(){
      
        return new Promise((resolve,reject)=>{

            //Clear the state lists
            this._unauthorizedStates_gridSettings.rows = [];
            this._authorizedStates_gridSettings.rows = [];
            this._adoptedStates_gridSettings.rows = [];

            //If this role cannot see the states, then just exit now
            if (!this._showAuthorizedStates()){
                resolve();
                return;
            }

            //Temp variables so we can sort "offscreen"
            let authStates = [];
            let unauthStates = [];
            let adoptedStates = [];

            //Load the states from the server (will be cached after the first time)
            //(We clone these because we are going to pull them out of the returned array and put them into two separate collections)
            //Get states list without child states, no longer using EF to grab states here
            //this.webServices.GetCached({ apiPath:"/@States", clone:true })
            this.webServices.GetCached({ apiPath:"/practices/getAllStatesNoChildren", clone:true })
            .then((res)=>{
                console.log("[practicesEdit:_populateStates$():GetCached()] (/practices/getAllStatesNoChildren, Default) res:", res);
            
                let allStates = res.data.DTO;
                let copyAllStates = [...allStates];

                //Move states that are in the practice's authorized list from the
                //allStates array into the authorized states array
                this._currentPractice.authorizedStates = this._currentPractice.authorizedStates || [];
                for (let authorizedStateCode of this._currentPractice.authorizedStates){

                    //Find this state by its state_code in the full states list
                    let idx = allStates.findIndex((state)=>{ return state.state_code == authorizedStateCode });

                    //This shouldn't happen, but let's keep it silent if it does
                    if (idx == -1){ continue; } 

                    //Move the state into the authorized state list
                    authStates.push(allStates.splice(idx,1)[0]);
                }

                //Set the unauthorized states list to the remaining states in the allStates list
                unauthStates = allStates;

                //Move states that are in the practice's adopted list from the
                //copyAllStates array into the adopted states array
                this._currentPractice.adoptedStates = this._currentPractice.adoptedStates || [];
                for (let adoptedStateCode of this._currentPractice.adoptedStates) {

                    //Find this state by its state_code in the full states list
                    let idx = copyAllStates.findIndex((state) => { return state.state_code == adoptedStateCode });

                    //This shouldn't happen, but let's keep it silent if it does
                    if (idx == -1) { continue; }

                    //Move the state into the adopted state list
                    adoptedStates.push(copyAllStates.splice(idx, 1)[0]);
                }

                //Sort the arrays
                this._sortStateData(authStates);
                this._sortStateData(unauthStates);
                this._sortStateData(adoptedStates);

                //Render the lists on screen
                this._unauthorizedStates_gridSettings.rows = unauthStates;
                this._authorizedStates_gridSettings.rows = authStates;
                this._adoptedStates_gridSettings.rows = adoptedStates;

                resolve();
            });
        
        });

    };

    //==================================
    // _practiceCodeChanged
    //==================================
    _practiceCodeChanged(){
        //console.log("   --> Syncing reporting_code to practice_code:", this._currentPractice.practice_code);
        this._changeInputValue("reporting_code", this._currentPractice.practice_code);
    };

    //==================================
    // _prepPracticeForSave
    //==================================
    // Creates a copy of the passed in practice with fields prepared for saving to DB
    // Currently that only includes the data fields which are in a custom format since
    // I added the bootstrap calendar control.
    _prepPracticeForSave(currentPractice){

        //Copy practice
        let practice = Object.assign({}, currentPractice);

        //Boolean prep
        practice.publish = practice.publish ? 'Y' : 'N';

        //Convert NgbDateStruct fields to date fields
        practice.start_date = practice.start_date ? new Date(practice.start_date).toISOString() : null;
        practice.sunset_date = practice.sunset_date ? new Date(practice.sunset_date).toISOString() : null;
        practice.end_date = practice.end_date ? new Date(practice.end_date).toISOString() : null;

        //TESTING
        //let ngbDt = this.ngbDateParser.dateToNgbDateStruct(practice.start_date);
        //let jsDt = this.ngbDateParser.ngbDateStructToDate(ngbDt);
        //console.log("    ngbDt", ngbDt);
        //console.log("    jsDt", jsDt);
        //TESTING

        //console.log(practice);

        return practice;
    };

    //==================================
    // _exportPractice
    //==================================
    _exportPractice() {
        if (!!this._currentPractice == false) {
            this.growlBox.addGrowl("error", "No asset selected.");
            return;
        }
        if (this._new_practice) {
            this.growlBox.addGrowl("error", "Can't export an asset that doesn't yet exist.");
            return;
        }
        let assetCopy = JSON.parse(JSON.stringify(this._currentPractice));
        assetCopy.authorizedStates = this._authorizedStates_gridSettings.rows.map(state => state.state_name_display.trim());
        assetCopy.adoptedStates = this._adoptedStates_gridSettings.rows.map(state => state.state_name_display.trim());
        assetCopy.authorizedStates = '"' + assetCopy.authorizedStates.toString().replaceAll(',', '\n') + '"';
        assetCopy.adoptedStates = '"' + assetCopy.adoptedStates.toString().replaceAll(',', '\n') + '"';
        this._callExportLibrary(assetCopy);
    }

    //==================================
    // _callExportLibrary
    //==================================
    _callExportLibrary(assetCopy) {
        exportCsvDTO(Object.keys(assetCopy).toString() + '\r\n' + Object.values(assetCopy).toString(), "Asset", assetCopy.practice_code);
    }

    //==================================
    // _refreshActionLinks
    //==================================
    _refreshActionLinks(){

        //New Practices
        if (this._new_practice) {
            //this.casNavBoxService.HideActionByName("act_delete_practice"); //BASECAMP-862
            this.casNavBoxService.HideActionByName("act_new_practice");
            this.casNavBoxService.HideActionByName("act_replace_practice");
            this.casNavBoxService.HideActionByName("act_export_practice");
        }
        else {
            //Editing existing
            //this.casNavBoxService.ShowActionByName("act_delete_practice"); //BASECAMP-862
            this.casNavBoxService.ShowActionByName("act_new_practice");
            this.casNavBoxService.ShowActionByName("act_replace_practice");
            this.casNavBoxService.ShowActionByName("act_export_practice");
        }

        //Close and Save are always visible
        this.casNavBoxService.ShowActionByName("act_close_practice");
        this.casNavBoxService.ShowActionByName("act_save_practice");

        this.casNavBoxService.ActionsLoading = false;
    };

    //==================================
    // _showAuthorizedStates
    //==================================
    _showAuthorizedStates(){
        //if (!this._fields_hash){ throw("[practicesEdit:_showAuthorizedStates()] Attempt to call _showAuthorizedStates() before this._fields_hash has been loaded."); };
        return this._fields.sec_authorized_states.show;
    };

    //BASECAMP-862
    ////==================================
    //// _showDeletePracticePopup
    ////==================================
    //_showDeletePracticePopup(){
    //    this.deletePracticePopup.Open();
    //};

    //==================================
    // _showBusinessRulePopup
    //==================================
    _showBusinessRulePopup(){
        this.businessRulePopup.Open();
    };

    //==================================
    // _sortStateData
    //==================================
    _sortStateData(arr){
        arr.sort((row1, row2) =>{
            return row1.state_name_display < row2.state_name_display ? -1 : (row1.state_name_display > row2.state_name_display ? 1 : 0);
        });
    };
   
    //==================================
    // _syncPracticeToStatesList
    //==================================
    // This function looks at the current authorized and adopted lists/grids and syncs the
    // current practice's data to match
    _syncPracticeToStatesList(){

        this._currentPractice.authorizedStates = [];
        this._currentPractice.adoptedStates = [];

        //Capture the authorized states
        this._authorizedStates_gridSettings.rows.forEach((row) => {
            this._currentPractice.authorizedStates.push(row.state_code);
        });

        //Capture the adopted states
        this._adoptedStates_gridSettings.rows.forEach((row) => {
            this._currentPractice.adoptedStates.push(row.state_code);
        });

        //console.log("===> authorizedStates:", this._currentPractice.authorizedStates);
        //console.log("===> adoptedStates:", this._currentPractice.adoptedStates);

        this._formChanged();
    };

    //==================================
    // _dv1_updatePractice
    //==================================
    _dv1_updatePractice() {

        this._disableUI();
        this.growlBox.addGrowl("info", "Saving...");

        // Process practice
        //---------------------------
        // Need to preprocess the paractice before submitting (date fields are a bootstrap structure)
        this._syncPracticeToStatesList();
        var practice = this._prepPracticeForSave(this._currentPractice);

        // Call Service
        //---------------------------
        this.webServices.Post("/practices/dv1_UpdatePractice", practice)
            .then(res => {

                console.log(`[${this._componentName}:_dv1_UpdatePractice()] - res: `, res);

                //Check for validation errors
                if (res.Success) {
                    this.growlBox.addGrowl("success", "Record Saved.");

                    //Mark the form clean
                    this._setPracticeClean();
                    this._enableUI();
                }
                else {
                    switch (res.ErrorCode) {

                        case "ERR-PBL-INP2":
                            this.growlBox.addGrowl("error", "Provided Practice Code is already in use.");
                            break;

                        //This one shouldn't happen if client side validation is working properly.
                        case "ERR-PBL-PUP1":
                            this.growlBox.addGrowl("error", "Invalid data provided.  Please verify form data.");
                            break;

                        case "ERR-PBL-PUPS1":
                            this.growlBox.addGrowl("error", "Invalid data provided.  Please verify form data.");
                            break;

                        case "ERR-PBL-RPIRPLC2":
                            this.growlBox.addGrowl("error", "Replacement code must be different than the assets's practice code");
                            break;

                        case "ERR-PBL-RPIRPLC3":
                            this.growlBox.addGrowl("error", "Provided Replacement Code not found.");
                            break;

                        case "ERR-PBL-SRPI2":
                            this.growlBox.addGrowl("error", "Provided Reporting Code not found.");
                            break;

                        case "ERR-EC-SE1":
                            this.growlBox.addGrowl("warn", "No email subject provided.");
                            break;

                        case "ERR-EC-SE2":
                            this.growlBox.addGrowl("warn", "No email message provided.");
                            break;

                        case "ERR-EC-SE3":
                            this.growlBox.addGrowl("warn", "Error sending email message. Mailbox busy or unavailable.");
                            break;

                        case "ERR-EC-SE4":
                            this.growlBox.addGrowl("warn", "Failed sending mail to recipient.");
                            break;

                        case "ERR-EC-SE5":
                            this.growlBox.addGrowl("warn", "Error sending email message: " + res.ErrorMessage);
                            break;

                        case "ERR-EC-SE6":
                            this.growlBox.addGrowl("warn", "Error finding or reading email template.");
                            break;

                        case "ERR-ZU-GSDS1":
                            this.growlBox.addGrowl("warn", "Unable to get State Data Steward info from ZRoles for state: {state}.");
                            break;

                        default:
                            this.growlBox.addGrowl("error", res.ErrorMessage);
                    }

                    this._enableUI();
                }
            })
            .catch(err => {
                this.growlBox.addGrowl("error", "An error occurred while saving.");
                console.log(this.cpdFormatters.formatError(err));
                this._enableUI();
            })

        this._enableUI();
    };

    ////==================================
    //// _updatePractice
    ////==================================
    //_updatePractice(){

    //    //Disable the form and navbox while saving
    //    this._disableUI();
    //    this.growlBox.addGrowl("info", "Saving...");

    //    // Process practice
    //    //---------------------------
    //    var practice = this._prepPracticeForSave(this._currentPractice);

    //    //Update
    //    this.webServices.UpdatePractice(practice)
    //    .then((res) => { 

    //        console.log("[practicesEdit:_updatePractice() - res:]", res); 
        
    //        //Check for validation errors
    //        if (res.Success){
    //            this.growlBox.addGrowl("success", "Record Saved.");

    //            //Mark the form clean
    //            this._setPracticeClean();
    //            this._enableUI();
    //        }
    //        else{
    //            if (res.ValidationErrors.length > 0){
    //                this.growlBox.addGrowl("error", "There were validation errors: " + this.cpdFormatters.formatValidationErrors(res.ValidationErrors));
    //            }
    //            else{
    //                this.growlBox.addGrowl("error", "An error occured while saving: " + this.cpdFormatters.formatError(res));
    //            }

    //            this._enableUI();
    //        }
    //    })
    //    .catch((err)=>{
    //        console.log("[practicesEdit:_updatePractice() - err:]", err);
    //        this._enableUI();
    //        this.growlBox.addGrowl("error", "An error occured while saving: " + this.cpdFormatters.formatError(err));
    //    })

    //};


    // HELPERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _changeInputValue
    //==================================
    // This function is to handle the annoying case where setting an element's value or model in code, does
    // not trigger an onChange event.  This must happen for validated fields, otherwise the validation will
    // not run and manually set values will not be properly validated
    //
    //  fieldName<str>:     //The field name must be the same for the actual element id AND the property name
    //                      //on this._currentPractice
    _changeInputValue(fieldName, newValue){
        //setTimeout(()=>{
            var element = document.getElementById(fieldName);
            element.value = newValue;
            this._currentPractice.reporting_code = element.value;
            var event = GetNewEvent('input'); //Has IE polyfill
            element.dispatchEvent(event);
        //},0);
    };

    //==================================
    // eGridToGrid
    //==================================
    eGridToGrid(eGrid) {

        //returns: { settings<obj>, component<obj> }

        switch (eGrid) {
            case this._eGrid.unauthorized: return { settings:this._unauthorizedStates_gridSettings, component:this.unauthorizedStatesGrid };
            case this._eGrid.authorized: return { settings:this._authorizedStates_gridSettings, component:this.authorizedStatesGrid };
            case this._eGrid.adopted: return { settings:this._adoptedStates_gridSettings, component:this.adoptedStatesGrid };
            default: throw(`eGridToGrid: Unrecognized eGrid value:${eGrid}`);
        }
    }



    // DEBUGGING
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _debugEntryClicked
    //==================================
    _debugEntryClicked(entry){
        console.log("[practicesEdit:_debugEntryClicked]");
        console.log("    ", entry);

        switch (entry){

            case "zRoles Test":
                this.webServices.ZRolesTest()
                .then((res) => { console.log("[ZRolesTest - res:]", res); })
                .catch((err)=>{ console.log("[ZRolesTest - err:]", err); })
                break;

            //case "BC503":
            //    this.growlBox.addGrowl("info", "Calling Basecamp 503 Test Service...");
            //    this._basecamp503_insertNewPractice(false);
            //    break;

            //case "BC503_ERR":
            //    this.growlBox.addGrowl("info", "Calling Basecamp 503 Test Service with forced error...");
            //    this._basecamp503_insertNewPractice(true);
            //    break;
        }

    };
    
}

    // REMOVE WHEN DONE WITH 368
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _addAllStates
    //==================================
    //// Adds all unauthorized states to the authorized states list
    //_addAllStates(){

    //    if (this._allFieldsDisabled){ return; }
    //    if (this._fields.sec_authorized_states && this._fields.sec_authorized_states.read_only){ return; }

    //    //Get buffer references to the array for off screen work
    //    var arrSource = this._unauthorizedStates_gridSettings.rows;
    //    var arrDest = this._authorizedStates_gridSettings.rows;
        
    //    //Clear the display while we work by clearing the grid references to the array in memory
    //    this._authorizedStates_gridSettings.rows = [];
    //    this._unauthorizedStates_gridSettings.rows = [];

    //    //Move the states in the buffer arrays
    //    //  (not using concat because there's no need to waste time on making new arrays)
    //    //  (not using push.apply() because I'd rather not risk playing with maximum paramter list sizes)
    //    while(arrSource.length > 0){
    //        arrDest.push(arrSource.splice(0,1)[0]);
    //    }

    //    //Sort the populated array
    //    this._sortStateData(arrDest);
        
    //    //Assign the array back to the populated list
    //    this._authorizedStates_gridSettings.rows = arrDest;

    //    //Update the practice's authorized states list
    //    this._syncPracticeToStatesList();
    //};



    ////==================================
    //// _authorizedStatesGrid_rowSelected
    ////==================================
    //// Moves a state from the authirized list to the unauthorized list
    //_authorizedStatesGrid_rowSelected(e){
        
    //    return;

    //    var arrSource = this._authorizedStates_gridSettings.rows;
    //    var arrDest = this._unauthorizedStates_gridSettings.rows;

    //    //Pull the selected item out of the authorized grid
    //    var state = arrSource.splice(arrSource.findIndex(s=>s.state_code==e.state_code), 1)[0]; //splice returns an array

    //    //Move the state into the authorized list
    //    arrDest.push(state);
        
    //    //Make sure the pushed row isn't flagged as selected
    //    this.unauthorizedStatesGrid.UnselectAllRows();

    //    //Resort the receiveing list
    //    this._sortStateData(arrDest);

    //    //Update the practice's authorized states list
    //    this._syncPracticeToStatesList();
    //};

    ////==================================
    //// _unauthorizedStatesGrid_rowSelected
    ////==================================
    //_unauthorizedStatesGrid_rowSelected(e){

    //    let arrSource = this._unauthorizedStates_gridSettings.rows;
    //    let arrDest = this._authorizedStates_gridSettings.rows;

    //    //Pull the selected item out of the authorized grid
    //    let state = arrSource.splice(arrSource.findIndex(s=>s.state_code==e.state_code), 1)[0]; //splice returns an array

    //    //Move the state into the authorized list
    //    arrDest.push(state);

    //    //Make sure the pushed row isn't flagged as selected
    //    this.authorizedStatesGrid.UnselectAllRows();

    //    //Resort the receiveing list
    //    this._sortStateData(arrDest);

    //    //Update the practice's authorized states list
    //    this._syncPracticeToStatesList();
    //};


